import { useEffect, useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  PieController,
  BarController,
  LineController,
  registerables
} from 'chart.js';

let chartRegistered = false;

export const useChartRegistration = () => {
  const [isRegistered, setIsRegistered] = useState(chartRegistered);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!chartRegistered) {
      try {
        // Register all Chart.js components
        ChartJS.register(
          ...registerables,  // This registers all scales, controllers, elements
          CategoryScale,
          LinearScale,
          PointElement,
          LineElement,
          BarElement,
          ArcElement,
          PieController,
          BarController,
          LineController,
          Title,
          Tooltip,
          Legend,
          Filler
        );
        
        chartRegistered = true;
        setIsRegistered(true);
        console.log("Chart.js components successfully registered");
      } catch (err) {
        console.error("Failed to register Chart.js components:", err);
        setError(err as Error);
      }
    }
  }, []);

  return { isRegistered, error };
};

export default useChartRegistration; 